<template>
  <span
    class="t-badge"
    :class="[
      `t-badge--${type}`,
      { 't-badge--soft': soft },
      { 't-badge--rounded': rounded },
    ]"
  >
    <span>
      <slot></slot>
    </span>
  </span>
</template>

<script>
import ColorTypeMixin from '../../mixins/ColorTypeMixin';

export default {
  name: 't-badge',
  props: {
    soft: Boolean,
    rounded: Boolean,
  },
  mixins: [ColorTypeMixin],
};
</script>
